import { useReactiveVar } from "@apollo/client";
import { Tabs, TabsProps } from "antd";
import { Dispatch, SetStateAction, useEffect } from "react";

import Spinner from "../../../components/layout/spinner/Spinner";
import NoPermission from "../../../components/others/NoPermission";
import { Colors } from "../../../constants/Colors";
import { ServiceTypes } from "../../../types/types";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import { __currentUser__ } from "../../../graphql/policies";
import { renderDecodedId } from "../../../utils/renderDecodedId";
import ContentTabContent from "./contentTabContent";
import FeedbackTabContent from "./feedbackTabContent";
import ThemeTabContent from "./themeTabContent";
import "./dailyCheckIn.scss";

interface ServiceBannerAndIconProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

const items: TabsProps["items"] = [
  {
    key: "1",
    label: "Theme",
    children: <ThemeTabContent />,
  },
  {
    key: "2",
    label: "Daily Content",
    children: <ContentTabContent />,
  },
  {
    key: "3",
    label: "Feedback",
    children: <FeedbackTabContent />,
  },
];

const DailyCheckIn = ({
  setSelectedService,
  setSelectSubItem,
}: ServiceBannerAndIconProps) => {
  const currentUser = useReactiveVar(__currentUser__);
  const {
    data: userPrograms,
    loading: userProgramsLoading,
    error: userProgramsError,
  } = useGetUserProgramsByServiceQuery({
    variables: {
      userId: parseInt(renderDecodedId(currentUser?.id)),
      serviceId: 10,
    },
  });

  useEffect(() => {
    setSelectedService(ServiceTypes.ZIPPY_AND_ME);
    setSelectSubItem("Daily Check-in");
  }, []);


  if (userProgramsLoading) {
    return <Spinner />;
  }

  if (
    userPrograms &&
    !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
      (item) => item.node.afProgram?.programName === "Daily Check-in"
    )
  ) {
    return <NoPermission />;
  }

  return (
    <div id="dailyCheckInWrapper">
      <div className="header" style={{ backgroundColor: Colors.white }}>
        <p className="header-title" style={{ color: Colors.darkGrey }}>
          Daily Check-in
        </p>
      </div>
      <Tabs
        defaultActiveKey="1"
        items={items}
        size="small"
        tabBarStyle={{
          paddingLeft: 24,
          backgroundColor: Colors.white,
          height: 50,
        }}
      />
    </div>
  );
};

export default DailyCheckIn;
